module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/SPORTS SCIENCE-b19391a484cb415e3023c896a62522c9.png";